<template>
    <div>
        <header class="main-header">
            <div class="main-header-wrapper container">
                <div class="logo-wrapper">
                    <router-link :to="{name: 'dashboard'}">
                        <img src="@/assets/images/logo-small.svg" alt="Sympatia" class="logo">
                    </router-link>
                </div>
                <navigation/>
            </div>
        </header>
        <div class="content-wrapper container">
            <router-view/>
        </div>
    </div>
</template>

<script>
    import Navigation from "../../components/Navigation";

    export default {
        name: "Private",
        components: {
            Navigation
        },
        mounted() {
            this.$store.dispatch('account/get').then((res) => {
                if (res.activated !== true) {
                    this.$router.push({name: 'verification'})
                }
            }).catch(() => {
                this.$router.push({name: 'login'})
            });
        },
    }
</script>

<style lang="scss">
    @import "@/assets/styles/variables.scss";


    .content-wrapper {
        @include media-breakpoint-down(lg) {
            margin-top: 100px;
        }
    }

    .main-header {
        background: #000000/*#0f0f0f*/;
        margin-bottom: 50px;

        @include media-breakpoint-down(lg) {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 90;
            margin-bottom: 0;
        }

        .btn-logout {
            border-color: #999;
            border-width: 2px;
            color: #999;
            padding: 5px 20px;
            text-transform: uppercase;
            font-size: 13px;
            font-weight: bold;
            margin-left: 10px;
        }

        .main-header-wrapper {
            display: flex;
            align-items: stretch;

            .logo-wrapper {
                margin-right: 40px;

                a {
                    display: block;
                    padding-top: 10px;
                    padding-bottom: 10px;

                    .logo {
                        height: 60px;

                        @include media-breakpoint-down(md) {
                            height: 40px;
                        }
                    }
                }
            }
        }

        .submenu-wrapper {
            margin-left: auto;

            @include media-breakpoint-down(lg) {
                margin-left: 0;
            }

            .btn {
                position: relative;
                outline: none;
                box-shadow: none;

                .badge {
                    $badgeSize: 18px;
                    position: absolute;
                    top: 0;
                    background: $red;
                    right: 0;
                    height: $badgeSize;
                    min-width: $badgeSize;
                    border-radius: $badgeSize/2;
                    font-size: 11px;
                }
            }
        }

        .menu-wrapper {
            .navbar-nav {
                .nav-item {
                    position: relative;

                    .nav-link {
                        padding: 0 5px;
                        margin: 0 10px;
                        line-height: 90px;
                        height: 90px;
                        color: #fff;
                        text-transform: uppercase;
                        border-bottom: 2px solid transparent;
                        font-size: 15px;

                        &.router-link-exact-active {
                            color: $blue;
                            border-color: $blue;
                        }
                    }

                    @include media-breakpoint-up(xl) {
                        &:not(:hover) {
                            > ul {
                                display: none;
                            }
                        }
                    }

                    > ul {
                        list-style: none;
                        padding: 15px 30px;
                        position: absolute;
                        width: 220px;
                        background: #000000 /*#0f0f0f*/;
                        z-index: 30;
                        top: 100%;
                        border-top: 5px solid #191919;

                        li {
                            a {
                                display: block;
                                color: #fff;
                                font-size: 13px;
                                line-height: 120%;
                                padding: 15px 0;

                                &:hover {
                                    color: $blue;
                                    text-decoration: none;
                                }
                            }

                            &:not(:first-child) a {
                                border-top: 1px solid #191919;
                            }
                        }
                    }

                    > ul:not(.dropdown-menu) {
                        @include media-breakpoint-down(lg) {
                            display: block;
                            position: relative !important;
                            width: 100% !important;
                        }
                    }

                    > ul.dropdown-menu {
                        @include media-breakpoint-down(lg) {
                            position: relative !important;
                            width: 100% !important;
                            transform: none !important;

                            a {
                                text-overflow: ellipsis;
                                overflow: hidden;
                            }
                        }
                    }
                }

                .users-wrapper {
                    max-height: 300px !important;
                    overflow-y: auto;
                }

                .users-wrapper::-webkit-scrollbar {
                    background-color: #373737;
                }

                .users-wrapper::-webkit-scrollbar-thumb {
                    background-color: white;
                }

                .users-wrapper-mobile {
                    ul {
                        max-height: 200px !important;
                        overflow-y: auto;
                    }

                    .nav-link {
                        text-transform: capitalize;
                    }
                }
            }
        }
    }
</style>